import { enableProdMode, importProvidersFrom } from '@angular/core';
import { environment } from './environments/environment';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app/app.component';
import { provideRouter, withComponentInputBinding, withRouterConfig } from '@angular/router';
import { routes } from './app/core/conf/app.route';
import { msalProviders } from './app/core/conf/msal.provider';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { LoadingInterceptor } from './app/core/interceptors/loading.interceptor';
import { BasicAuthInterceptor } from './app/core/interceptors/basic.auth.interceptor';
import { CachingInterceptor } from './app/core/interceptors/caching.interceptor';
import { WorksheetInterceptor } from './app/core/interceptors/worksheet.interceptor';
import { MaterialApplicationInterceptor } from './app/core/interceptors/material-application.interceptor';
import { FertilizerApplicationInterceptor } from './app/core/interceptors/fertilizer-application.interceptor';
import { MaterialTypeInterceptor } from './app/core/interceptors/material-type.interceptor';
import { PreferenceInterceptor } from './app/core/interceptors/preference.interceptor';
import { ErrorInterceptor } from './app/core/interceptors/error.interceptor';
import { MsalModule, MsalRedirectComponent } from '@azure/msal-angular';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { DecimalPipe } from './app/shared/pipes/decimal.pipe';
import { DatePipe } from '@angular/common';
import { AgrisuitePaginatorIntl } from './app/shared/components/paginator/paginator.component';

if (environment.production) {
  enableProdMode();
}

const APP_DATE_FORMATS = {
  parse: {
    dateInput: 'LL'
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(BrowserModule, BrowserAnimationsModule, MsalModule),
    provideRouter(routes, withComponentInputBinding(), withRouterConfig({ onSameUrlNavigation: 'reload' })),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    // MSAL providers
    ...msalProviders,
    // HTTP Interceptors
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: BasicAuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: CachingInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: WorksheetInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: MaterialApplicationInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: FertilizerApplicationInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: MaterialTypeInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: PreferenceInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    // Date adapter
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
    // Form field default options
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        subscriptSizing: 'dynamic'
      }
    },
    // Paginator internationalization
    { provide: MatPaginatorIntl, useClass: AgrisuitePaginatorIntl },
    // Pipes used by root-level services
    DecimalPipe,
    DatePipe
  ]
}).catch(err => console.error(err));
